module.exports = __webpack_public_path__ + "static/img/downloadapp.ab18eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadapp.png
// module id = f89U
// module chunks = 20